

































import CInternationalTelephoneInput from '~/components/shared/configurable/form/input/CInternationalTelephoneInput.vue'
import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import { Ref } from '@vue/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import CAppTelephoneButton from '~/components/shared/configurable/button/CAppTelephoneButton.vue'
import { TelephoneSocial } from '~/constants/telephone/social'

export default defineComponent({
  components: {
    FieldError,
    CAppTelephoneButton,
    CInternationalTelephoneInput
  },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = props

    const dontShowToPublic = ref(false)
    const telephone = ref({
      code: null,
      telephone: null
    })
    const viber = ref(false)
    const whatsApp = ref(false)

    function onValue(v: Ref<any>) {
      telephone.value.telephone = v.value?.telephone || null
      telephone.value.code = v.value?.code || null

      dontShowToPublic.value = v.value?.dont_show_to_public || false

      viber.value = Boolean(v.value?.social?.viber)
      whatsApp.value = Boolean(v.value?.social?.whatsapp)
    }

    const {
      error,
      isValid,
      debouncedValueChanged,
      valueChanged
    } = useClassifiedForm(props, { onValue })

    const allowNonPublic = computed(() => specs?.allow_non_public || false)
    const countries = computed(() => specs.countries)

    const handleTelephoneInput = (tel: any) => {
      debouncedValueChanged(name, {
        ...tel,
        dont_show_to_public: dontShowToPublic.value,
        social: {
          viber: Boolean(viber.value),
          whatsapp: Boolean(whatsApp.value)
        }
      })
    }

    const handleMiscChange = (_social: any) => {
      valueChanged(name, {
        ...telephone.value,
        dont_show_to_public: dontShowToPublic.value,
        social: {
          viber: Boolean(viber.value),
          whatsapp: Boolean(whatsApp.value)
        }
      })
    }

    return {
      dontShowToPublic,
      telephone,
      TelephoneSocial,
      viber,
      whatsApp,
      error,
      isValid,
      allowNonPublic,
      countries,
      handleTelephoneInput,
      handleMiscChange
    }
  }
})
